export default __webpack_public_path__ + "static/media/whats_app.69c70dcc.png";